module.exports = __webpack_public_path__ + "img/marksmens_encampment_small.41583533.png";